import { useAppDispatch } from "core/utils";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { showSuccessNotification } from "../../../core/setup/redux/state/notifications/notificationsState";
import type { FormSubmitAction } from "../types/FormProps";

/**
 * Call after a form's save mutation resolves successfully. Dispatches the success notification,
 * then redirects: "ok" always goes to `listPath`. "submit" goes to `submitRedirectPath` if given
 * (e.g. a create form sending the user to the new entity's edit page), otherwise stays on the
 * current page (e.g. an edit form, where there is nowhere further to go).
 */
export const useFormSubmitCompletion = (formAction: FormSubmitAction | undefined, listPath: string) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return useCallback(
        (successText: string, submitRedirectPath?: string) => {
            dispatch(showSuccessNotification({ text: successText, autoCloseDisabled: false }));

            if (formAction === "ok" || formAction === "generate") {
                navigate(listPath);
            } else if (submitRedirectPath) {
                navigate(submitRedirectPath);
            }
        },
        [dispatch, navigate, formAction, listPath],
    );
};
